import React from 'react';
import { Creatable, TextInput } from 'ui-toolkit';
import generateRecordingFeeOptions from '../utilities/generateRecordingFeeOptions';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { CdLabelCell } from '../CdLabelCell.styles';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { IRecordingFeeOtherViewItem, IRecordingFeeViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { generateDefaultViewItem } from '../../../ui-toolkit/cdItems/data/generateDefaultViewItem';
import { eRecordingFees } from '../../../ui-toolkit/enums/eRecordingFees';
import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';

const recordingFeesOptions = generateRecordingFeeOptions();

interface IRecordingFee
  extends IItemProps,
    IHasItemDataProps<IRecordingFeeViewItem | IRecordingFeeOtherViewItem>,
    Required<IHasItemEventProps<IRecordingFeeViewItem | IRecordingFeeOtherViewItem>> {}

export default class RecordingFee extends React.Component<IRecordingFee> {
  constructor(props: IRecordingFee) {
    super(props);
    this.onOptionSelected = this.onOptionSelected.bind(this);
  }

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const selectedValue =
      data.type === eCDV3ItemTypes.recording_fee
        ? recordingFeesOptions.find((option) => option.value === (data as IRecordingFeeViewItem).sub_type)
        : {
            label: (data as IRecordingFeeOtherViewItem).label,
            value: (data as IRecordingFeeOtherViewItem).label,
          };
    const compareOption = (inputValue: string, option: { label: string }) =>
      option.label.toLowerCase() === inputValue.toLowerCase();
    const isValidNewOption = (inputValue: string, selectValue: any, selectOptions: ReadonlyArray<any>) => {
      return !(!inputValue || selectOptions.some((option) => compareOption(inputValue, option)));
    };

    const isSubtypeLocked = !data.new && !!selectedValue;

    const myOnChangeEvent = createOnChangeHandlerGenerator(data, onChange);
    const payeeOnChange = myOnChangeEvent('payee');
    return (
      <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
        <CdLabelCell gridTemplateColumns={isSubtypeLocked ? undefined : '1fr min-content 1fr'}>
          {isSubtypeLocked ? (
            <span>{`${selectedValue!.label}`}</span>
          ) : (
            <Creatable
              isValidNewOption={isValidNewOption}
              onChange={this.onOptionSelected}
              options={recordingFeesOptions}
              value={selectedValue}
              isDisabled={!hasEditPermissions}
            />
          )}
          <span>to</span>
          <TextInput
            onChange={payeeOnChange}
            placeholder="Payee"
            value={data.payee}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
        </CdLabelCell>
      </SharedItemCells>
    );
  }

  protected onOptionSelected(option?: { label: string; value: eRecordingFees | string; __isNew__?: boolean } | null) {
    const { data, onChange } = this.props;
    const { label, sub_type, ...rest } = data as Partial<{ label: string; sub_type: eRecordingFees }>;
    if (option && option.value) {
      if (option.__isNew__) {
        // FYI: always set to recording_fee_other because isNew means custom/other
        onChange({
          ...generateDefaultViewItem(),
          ...rest,
          label: option.value,
          dirty: true,
          type: eCDV3ItemTypes.recording_fee_other,
        });
      } else {
        // FYI: always set to recording_fee because option as object means enum/sub_type
        onChange({
          ...generateDefaultViewItem(),
          ...rest,
          sub_type: option.value as any,
          dirty: true,
          overridden: false,
          type: eCDV3ItemTypes.recording_fee,
        });
      }
    } else {
      onChange({
        ...generateDefaultViewItem(),
        ...rest,
        dirty: true,
        overridden: false,
        type: eCDV3ItemTypes.recording_fee,
      });
    }
  }
}
